import { render, staticRenderFns } from "./f2.vue?vue&type=template&id=cc89b762&scoped=true&"
import script from "./f2.vue?vue&type=script&lang=js&"
export * from "./f2.vue?vue&type=script&lang=js&"
import style0 from "./f2.vue?vue&type=style&index=0&id=cc89b762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc89b762",
  null
  
)

export default component.exports